import { VarianteChip } from '../ui';
import { TermoTemplate } from '../api/termo-template/termoTemplateApi';

/**
 * Regras de apresentação do catálogo de tipos de termo (at-69, frente D/D7).
 *
 * ⚠️ **Nada aqui decide se um tipo é gerável** — quem decide é o backend, e ele
 * já manda `transcricaoPendente` e `geravel` resolvidos (at-40). Estas funções só
 * **compõem** texto, cor e explicação a partir do que veio, que é a convenção do
 * projeto desde a at-24: a regra mora num lugar só, a tela renderiza.
 */

export interface RotuloSituacaoTemplate {
  texto: string;
  variante: VarianteChip;
  /**
   * O que o estado significa. Era um `title` na tabela antiga — invisível no
   * celular e no teclado (at-65), justamente onde o TI mais precisa dele.
   */
  descricao: string;
}

/**
 * Os três estados são mutuamente exclusivos, e a ORDEM da checagem importa: um
 * tipo sem texto também está inativo (a carga inicial os criou assim), e dizer
 * "Desativado" ali esconderia a ação que o TI precisa tomar — transcrever.
 */
export function rotuloSituacaoTemplate(tipo: TermoTemplate): RotuloSituacaoTemplate {
  if (tipo.transcricaoPendente) {
    return {
      texto: 'Sem texto',
      variante: 'pendente',
      descricao: 'Aguardando a transcrição das cláusulas.',
    };
  }

  if (!tipo.ativo) {
    return {
      texto: 'Desativado',
      variante: 'neutro',
      descricao: 'Tem texto, mas está desativado para geração.',
    };
  }

  return {
    texto: 'Gerável',
    variante: 'ok',
    descricao: 'O SAAC gera o contrato deste tipo.',
  };
}

/**
 * "Listar os produtos linha a linha" só se aplica quando as **duas** tabelas
 * aparecem no PDF — é a regra do motor de geração, e o editor sempre a teve
 * (`disabled` + `title`). Aqui ela vira função para a tela poder dizer **por
 * quê** em texto, não só travar o controle.
 */
export function listarProdutosDisponivel(
  mostrarProdutos: boolean,
  mostrarValores: boolean,
): boolean {
  return mostrarProdutos && mostrarValores;
}

/** O motivo da trava, em linguagem de usuário. `null` quando não está travado. */
export function motivoListarProdutosTravado(
  mostrarProdutos: boolean,
  mostrarValores: boolean,
): string | null {
  if (listarProdutosDisponivel(mostrarProdutos, mostrarValores)) return null;

  return 'Só se aplica quando a tabela de produtos e a de valores estão exibidas.';
}
